import React, { useContext, useEffect, useState } from "react";
import EmpresaContext from "../../context";
import styled from "styled-components";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import * as rdrLocales from "react-date-range/dist/locale";
import { addDays } from "date-fns";

const DateRangeStyle = styled.div<DatePickerProps>`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 10px;
  label {
    position: relative;
    margin: 0;
    cursor: pointer;
    span {
      position: absolute;
      font-size: 12px;
      color: #242424;
      top: -10px;
      user-select: none;
      padding-left: 0;
      ${props =>
        !props.sideForm &&
        `
        background: #fff;
        padding: 2px 4px;
        left: 15px;
      `};
    }
  }
  input {
    width: 100%;
    height: 56px;
    padding: 0 20px;
    border: 1px solid #e7e7eb;
    border-radius: 4px;
    transition: all 0.4s ease;
    min-height: 48px;
    cursor: pointer;
    &:hover,
    &:focus {
      border: 1px solid #2684ff;
    }
  }
  .calendar-container {
    position: absolute;
    z-index: 10;
    top: 130px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    display: none;
    ${props =>
      props.singleColumn &&
      `
        right: 0;
      `} ${props =>
      props.sideForm &&
      `
        top: 100px;
      `};
  }
  &:focus-within {
    .calendar-container {
      display: block;
    }
  }
  .rdrDefinedRangesWrapper {
    display: none;
  }
  @media screen and (min-width: 1100px) {
    grid-template-columns: ${props => (props.singleColumn ? "1fr" : "1fr 1fr")};
    grid-gap: 20px;
    .calendar-container {
      top: 62px;
      grid-column: ${props => (props.singleColumn ? "span 1" : "span 2")};
      ${props =>
        props.sideForm &&
        `
        top: 110px;
      `};
    }
    input {
      height: 100%;
    }
  }
`;

interface DatePickerProps {
  singleColumn?: boolean;
  sideForm?: boolean;
  disabledDays?: Date[];
  // onChangeDataPicker?: (dates: Date[]) => void
  onChangeDataPicker?: any;
  defaultStartDate?: Date | null;
  defaultEndDate?: Date | null;
}

const DatePicker = (props: DatePickerProps) => {
  const context = useContext(EmpresaContext);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(addDays(new Date(), 1));
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    if (props.defaultStartDate && props.defaultEndDate) {
      setStartDate(props.defaultStartDate);
      setEndDate(props.defaultEndDate);
    }
    if (window.innerWidth <= 760) {
      setMobile(true);
    }
  }, []);
  const handleSelect = ranges => {
    // console.log(ranges)
    // {
    //   selection: {
    //     startDate: [native Date Object],
    //     endDate: [native Date Object],
    //   }
    // }
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
    try {
      //@ts-ignore
      props.onChangeDataPicker([
        ranges.selection.startDate,
        ranges.selection.endDate
      ]);
    } catch (error) {
      console.log("falto a função pra atualizar o state");
    }
  };
  const convertDate = date => {
    return date.toLocaleString("pt-br", {
      day: "numeric",
      month: "short"
    });
  };
  const selectionRange = {
    startDate,
    endDate,
    key: "selection"
  };
  return (
    <DateRangeStyle {...props}>
      <label>
        <span>Check-in</span>
        <input value={convertDate(startDate)} />
      </label>
      <label>
        <span>Checkout</span>
        <input value={convertDate(endDate)} />
      </label>
      <div className="calendar-container">
        <DateRangePicker
          ranges={[selectionRange]}
          rangeColors={[context.palleta.cor_primaria]}
          onChange={handleSelect}
          months={2}
          direction={mobile ? "vertical" : "horizontal"}
          minDate={new Date()}
          staticRanges={[]}
          inputRanges={[]}
          locale={rdrLocales.pt}
          dateDisplayFormat="d MMM yyyy"
          showDateDisplay={false}
          disabledDates={props.disabledDays}
          // disabledDay={() => false}
        />
      </div>
    </DateRangeStyle>
  );
};

export default DatePicker;
